import { mapActions, mapState } from 'vuex'
import {
	LOAD_NOTIFICATION_TYPES,
	LOAD_PORT_LAG_INTERFACES,
	LOAD_TICKET_SUPPORT_AREAS,
	LOAD_TICKET_INCIDENT_TYPES,
	LOAD_ZONE_RECORD_TYPES,
	LOAD_ZONE_SOAS,
	LOAD_ISM_COMMANDS,
	LOAD_ISM_SOURCES,
} from '@/store/types'

export default
{
	computed:
	{
		...mapState
		({
			notificationTypes:   state => state?.lookups?.notificationTypes,
			portLagInterfaces:   state => state?.lookups?.portLagInterfaces,
			ticketSupportAreas:  state => state?.lookups?.ticketSupportAreas,
			ticketIncidentTypes: state => state?.lookups?.ticketIncidentTypes,
			zoneRecordTypes:     state => state?.lookups?.zoneRecordTypes,
			zoneSOAs:            state => state?.lookups?.zoneSOAs,
			ismCommands:         state => state?.lookups?.ismCommands,
			ismSources:          state => state?.lookups?.ismSources,
		}),
	},

	methods:
	{
		...mapActions
		({
			loadNotificationTypes:   LOAD_NOTIFICATION_TYPES,
			loadPortLagInterfaces:   LOAD_PORT_LAG_INTERFACES,
			loadTicketSupportAreas:  LOAD_TICKET_SUPPORT_AREAS,
			loadTicketIncidentTypes: LOAD_TICKET_INCIDENT_TYPES,
			loadZoneRecordType:      LOAD_ZONE_RECORD_TYPES,
			loadZoneSoas:            LOAD_ZONE_SOAS,
			loadIsmCommands:         LOAD_ISM_COMMANDS,
			loadIsmSources:          LOAD_ISM_SOURCES,
		}),
	},
}